export const LEAD_ORIGINS = [
  'Sitio Web - Whatsapp',
  'Sitio Web - Formulario',
  'Importador',
  'Meta',
  'Google',
  'TikTok',
  'Orgánico',
  'Campaña Outbound',
  'Mailing',
  'Portales',
  'Campaña Tradicional',
  'Buk',
  'Lank',
] as const;

export const LEAD_SUB_ORIGINS = [
  'Autoshopping',
  'Autosusados',
  'Búsqueda',
  'Chileautos',
  'Click a Mensaje',
  'Click a WhatsApp',
  'Discovery',
  'Display',
  'Encuesta',
  'Eventos',
  'Formulario',
  'Landing',
  'MercadoLibre',
  'Neoauto',
  'Orgánico',
  'Orgánico (fbclid)',
  'Predictivo',
  'Prensa',
  'Promociones',
  'Remarketing',
  'Shopping',
  'TV',
  'Unknown',
  'Vía Pública',
  'Yapo',
  'YouTube',
] as const;
